import { StringIndexedObject } from '@kanda-libs/ks-design-library';
import { ConsumerSignature, Customer } from '@kanda-libs/ks-frontend-services';
import { cleanObject, formatPhoneNumber } from 'utils';
import {
  EnquiryQuoteContactDetailsFormTerms,
  EnquiryQuoteContactDetailsFormValues,
} from './useEnquiryQuoteContactDetailsForm';

export interface FormattedEnquiryContactDetailsBodies {
  consumer: Customer;
  consumerSignature: ConsumerSignature;
}

export const formatConsumer = (consumer: Customer): Customer =>
  cleanObject({
    ...consumer,
    phone: formatPhoneNumber(consumer.phone),
  });

export const formatConsumerSignature = (
  terms: EnquiryQuoteContactDetailsFormTerms,
): ConsumerSignature => ({
  pre_application_declarations: {},
  signature: {
    signed: terms.agreed_terms.value ? 'yes' : 'no',
    fingerprint: terms.ip,
  },
});

export const formatEnquiryQuoteContactFormValues = (
  formValues: StringIndexedObject<EnquiryQuoteContactDetailsFormValues>,
): FormattedEnquiryContactDetailsBodies => {
  const fv = formValues as unknown as EnquiryQuoteContactDetailsFormValues;
  const { customer, terms } = fv;
  return {
    consumer: formatConsumer(customer),
    consumerSignature: formatConsumerSignature(terms),
  };
};
